import React from "react";
import Loader from 'react-loader-spinner'
import FilterModal from "../../modals/FilterModal";
import { getBoundingClientRect } from "../../utils/functions";

import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, imageAddress, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import SingleProductVariants from "../../windows/Applets/SingleProductVariants";
import SingleProductAdditionals from "../../windows/Applets/SingleProductAdditionals";
import SingleProductSubscriptions from "../../windows/Applets/SingleProductSubscriptions";

class ProductSelectInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0,
        search: '',
        activeVariants: null,
        activeAdditionals: null

    }



    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {

        if (prevProps.data != this.props.data && this.mounted) {
            // this.init()
        }

        if (prevProps.fetchedData != this.props.fetchedData) {
            // console.log(prevProps.fetchedData)
            this.init(true)
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }



    init(newFetchData) {
        // console.log("init",newFetchData, this.props.extra,this.props.fetchedData)
        if (this.props.header.information) {
            if (this.props.header.information.type == "local" || newFetchData || this.props.fetchedData) {

                let options = []
                let choosen

                if (this.props.header.information.items && this.props.header.information.items.length > 0) {
                    options = this.props.header.information.items
                }

                if (Array.isArray(this.props.fetchedData) && this.props.fetchedData.length > 0) {
                    options = this.props.fetchedData
                }
                // console.log(options)

                if (this.props.data) {
                    for (let i = 0; i < options.length; i++) {
                        const option = options[i];
                        if (option.value == (this.props.data?._id ?? this.props.data)) {
                            choosen = option
                        }

                    }
                }

                this.setState({ isLoading: false })


                // if (this.props.data && Array.isArray(this.props.data)) {
                //     this.props.data.forEach(element => {
                //         choosen.push({ title: element, value: element })
                //     });
                // }
                // console.log(this.props.title)
                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch(true)
            }
        }
    }


    fetch(init) {
        // console.log("FETCH")
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter
        // console.log(filter)
        // console.log(filter)

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }

        // if (init) {

        //     if (!this.props.data) {
        //         return
        //     }

        //     if (!filter.filter) {
        //         filter.filter = {}
        //     }
        //     // console.log(this.props.data)

        //     filter.filter['_id'] = this.props.data?._id ?? this.props.data
        // }

        // console.log(this.props.extra, this.props.setFetchedData)

        if (this.props.extra?.index != null && this.props.extra?.index != 0 && init && this.props.setFetchedData) {
            return
        }

        // console.log(address, filter)

        // console.log('aaaaaaaaa',address,filter)



        HttpService.request(address, filter, (fetchResult, fetchError) => {
            // console.log('aaaaaaaaaaaaaaaaaaa',fetchResult.info);
            if (fetchError) { return }



            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            let newData = []
            let newParents = []
            let choosen

            fetchResult.info.sort((a, b) => { return a.values?.parent - b.values?.parent })

            // console.log(fetchResult)
            fetchResult.info.forEach(element => {
                let object = element
                for (const [key, value] of Object.entries(this.props.header.information.fields)) {
                    object[key] = getObject(element, value)

                    if (typeof object[key] == 'object' && object[key]?._id && key != 'image') {
                        object[key] = object[key]._id
                    }
                }



                newData.push(object)

                let parent = this.spliter(element, this.props.header.information.fields.parent)

                if (parent && parent != '') {
                    // newData.push({ value: newValue, title: newTitle, image: newImage, description: newDescription, parent: (typeof parent == 'object' ? parent._id : parent) })

                } else {
                    newParents.push(object)
                }

            });


            newParents.sort((a, b) => { return a.values?.name - b.values?.name })


            if (this.props.data) {

                let data = this.props.data
                if (Array.isArray(data)) {
                    data = data[0]
                }

                if (typeof data == 'object') {
                    data = data._id
                }

                newData.forEach(oneNewData => {
                    if (oneNewData.value == data) {

                        choosen = oneNewData
                        // this.setState({ choosen: oneNewData }, () => {
                        //     this.changeValue(false)
                        // })
                        // choosen.push({ title: oneNewData.title, value: oneTitleId })
                    }
                })
            }

            // console.log(this.props.extra, this.props.setFetchedData)
            if (this.props.extra?.index == 0 && this.props.setFetchedData) {

                this.props.setFetchedData(this.props.header?.key, newData)
            }


            this.setState({
                options: newData,
                parents: newParents,
                isLoading: false,
                choosen
            }, () => {
                let updateVariants = true
                if (choosen && this.props.fullData?.variants) {
                    updateVariants = false
                }

                this.changeValue(updateVariants, true)
                setTimeout(() => {

                    if (this.props.header.information.autoFocus && !this.props.data) {
                        this.toggleOpen(true)
                    }
                }, 200);

            })
        })

    }



    setDefaultVariant = (product) => {

        let activeVariants = {}

        if (product) {
            if (product?.type == 'membership') {

                if (Array.isArray(product?.subscriptionPrice) && product?.subscriptionPrice?.length > 0 && product?.priceType == 'subscription') {
                    // product?.subscriptionPrice.forEach(variant => {
                    let variant = product?.subscriptionPrice[0]
                    activeVariants = { duration: variant.duration, repeat: variant.repeat, }

                    // })
                }

            } else {

                if (Array.isArray(product?.variants)) {
                    product?.variants.forEach(variant => {

                        if (Array.isArray(variant.options)) {
                            if (variant.name) {
                                activeVariants[variant.name.toLowerCase()] = variant.options[0]
                            }
                        }
                    })
                }
            }
        }


        this.setActiveVariant(activeVariants, () => {
            // console.log(activeVariants)
            if (this.variantsfixedView && activeVariants && Object.keys(activeVariants).length > 0) {
                // console.log("OPEN")
                this.variantsfixedView.showView()
            }
        })
        // this.setState({ activeVariants })
    }


    toggleOpen = (open) => {
        // console.log("toggleOpen")
        let openState = open != null ? open : !this.state.isOpen

        if (this.fixedView) {
            if (openState) {

                this.fixedView.showView()

            } else {

                this.fixedView.hideView()

            }
        }

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }



    changeItem = (prop, selected, dontChangeValue) => {

        // console.log(prop)
        // var choosen = this.state.choosen
        if (this.state.choosen?.value != prop.value) {
            this.setState({ title: '', search: '', choosen: prop }, () => {
                this.changeValue(true)
                if (this.state.tempData.length > 0)
                    this.setState({ options: this.state.tempData })

                // if (this.refs.input)
                //     this.refs.input.focus()
            })
        }


        // if (selected) {
        //     for (let i = 0; i < choosen.length; i++) {

        //         if (choosen[i].value == prop.value) {
        //             choosen.splice(i, 1)
        //         }
        //     }
        // } else {
        //     choosen.push(prop)
        // }

        // this.setState({ choosen }, () => {
        //     if (!dontChangeValue) 
        // })

        // console.log("CHANGE")
        setTimeout(() => {
            this.toggleOpen(false)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );




        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }



    spliter(source, string) {
        let finalString = source
        // console.log(stringArray[0])
        // console.log("targetId")

        if (string) {
            let stringArray = string.split('.')

            for (let i = 0; i < stringArray.length; i++) {
                const element = stringArray[i];
                // console.log(element)
                // console.log(finalString)
                finalString = finalString[element]
                // console.log(finalString)

            }

        }
        return finalString
    }




 

    search = async (value) => {
        this.setState({ title: value, search: value });
    
        if (!this.state.isOpen) {
            this.toggleOpen();
        }
    
        if (value === "") {
            await this.setState({ options: this.state.tempData });
            await this.setState({ tempData: [] });
            return;
        }
    
        // Store original options if tempData is empty
        if (this.state.tempData.length === 0) {
            await this.setState({ tempData: this.state.options });
        }
    
        // Normalize the search value and prepare for comparison
        const normalizedSearch = this.normalizeString(value);
        const values = [];
    
        this.state.tempData.forEach(element => {
            // Normalize all string fields for comparison
            const normalizedTitle = this.normalizeString(element.title);
            const normalizedBarcode = this.normalizeString(element.barcode);
            const normalizedSKU = this.normalizeString(element.SKU || '');
    
            if (
                normalizedTitle.includes(normalizedSearch) ||
                normalizedBarcode.includes(normalizedSearch) ||
                normalizedSKU.includes(normalizedSearch) ||
                element.barcode === value
            ) {
                values.push(element);
            }
    
            if (element.barcode === value) {
                this.changeItem(element);
            }
        });
    
        this.setState({ options: values });
    }
    
    // Helper function to normalize strings for comparison
    normalizeString = (str) => {
        if (typeof str !== 'string') return '';
        
        return str
            .normalize('NFKD') // Normalize to decomposed form
            .replace(/[\u064A\u0649\u06CC\u06CE\u06CD\u06D0\u06D1\u06D2\u06D3]/g, '\u06CC') // Normalize all Yeh variants to Farsi Yeh
            .replace(/[\u0643\u06A9\u06AA\u06AB\u06AC\u06AD\u06AE\u06AF]/g, '\u06A9') // Normalize Kaf variants
            .replace(/[\u0629\u0647\u06BE\u06C0\u06C1\u06C2\u06C3\u06C4\u06C5\u06C6\u06C7\u06C8\u06C9\u06CA\u06CB\u06CC\u06CD\u06CE\u06CF]/g, '\u0647') // Normalize Heh variants
            .replace(/[\u0622\u0623\u0625\u0671\u0672\u0673\u0675\u06C0\u06C1\u06C2\u06C3\u06D3]/g, '\u0627') // Normalize Alef variants
            .toLowerCase();
    }



    changeValue(updateVariants, init) {
        // let choosen = []
        // this.state.choosen.forEach(element => {
        //     choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
        //     // choosen.push((element.value))

        // });
        // console.log(choosen)
        // console.log(this.state.choosen)
        let finalValue
        if (this.props.header.information.returnFullValue) {

            finalValue = this.state.choosen
        } else {

            finalValue = (typeof (this.state.choosen == 'object' && !Array.isArray(this.state.choosen)) ? this.state.choosen?.value : this.state.choosen)
        }

        // if(this.props.header.information?.sendArray){
        //     finalValue = [finalValue]
        // }
        // console.log(updateVariants,this.state.choosen)
        if (updateVariants) {
            this.setDefaultVariant(this.state.choosen)
            this.setActiveAdditionals(null)
        } else {
            this.setActiveVariant(this.props.fullData?.variants, () => { })
            this.setActiveAdditionals(this.props.fullData?.additionals)
        }
        if (String(finalValue) != String(this.props.data)) {

            this.props.changeValue(this.props.header.key, finalValue, this.props.extra, this.state.choosen, init)
        }
    }



    setActiveVariant = (activeVariants, cb) => {

        this.setState({ activeVariants }, () => {

            this.props.changeValue('variants', activeVariants, this.props.extra, this.state.choosen, true)

            cb()
        })
    }




    setActiveAdditionals = (activeAdditionals) => {

        this.props.changeValue('additionals', activeAdditionals, this.props.extra, this.state.choosen, true)

        this.setState({ activeAdditionals }, () => {
        })

    }




    openFilter = () => {
        this.filterModal.modal.showModal()
    }




    showVariants = (product) => {


        let repeat
        let duration

        let isSubscription = product?.type == 'membership' && product?.priceType == 'subscription' && Array.isArray(product?.subscriptionPrice) == true && product?.subscriptionPrice?.length > 0

        if (isSubscription && this.state.activeVariants) {
            repeat = this.state.activeVariants?.repeat ?? 1
            duration = (this.state.activeVariants?.duration ?? 'year') + (repeat > 1 ? 's' : '')

            if (repeat == 1) {
                switch (duration) {
                    case 'year':
                        duration = 'Yearly'
                        break;

                    case 'month':
                        duration = 'Monthly'
                        break;

                    case 'Week':
                        duration = 'Weekly'
                        break;

                    default:
                        break;
                }
            }
        }


        return (
            <>
                {/* {product?.type != 'membership' && (
                    <button className='mb-1' >
                        <p className='font-size-16 weight-600 '>{checkTranslation(product?.name)}</p>
                    </button>
                )} */}

                {/* {product?.type == 'membership' && (
                    <div className='mb-1' >
                        <p className='font-size-16 weight-600 '>{translate("Subscribe")}: {checkTranslation(product?.name)} - {this.state.activeVariants?.repeat} {translate(this.state.activeVariants?.duration)}</p>
                    </div>
                )} */}


                {/* {product?.type == 'membership' && (
                    <p className='text-small'>USD {this.state.activeVariants?.price}</p>
                )} */}

                {/* {product?.type == 'membership' && this.state.activeVariants?.duration == 'year' && (
                    <p className='text-small'>Billed annualy</p>
                )} */}

                {isSubscription && this.state.activeVariants && (

                    <p className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}>{repeat > 1 ? `${repeat} - ` : ''}{translate(duration)}</p>

                )}


                {product?.type != 'membership' && this.state.activeVariants && (
                    <div className='w-100'>
                        {Object.entries(this.state.activeVariants)?.map(([key, value]) => {
                            return (
                                <p className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-13'>{key}:</span> {value}</p>
                            )
                        })}
                    </div>
                )}


                {typeof this.state.activeAdditionals == 'object' && (
                    <div className='w-100'>
                        {this.state.activeAdditionals && Object.entries(this.state.activeAdditionals)?.map(([key, value]) => {
                            return (
                                <div>
                                    <span className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize' }}>{key}:
                                        {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                            return (
                                                <span>
                                                    {optionKey == 'text' ? (
                                                        <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                    ) : (
                                                        <>
                                                            <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                {(optionValue?.priceDifference != null && optionValue?.priceDifference > 0) && (
                                                                    <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                        ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                    </span>
                                                                )}
                                                            </span>

                                                        </>
                                                    )}
                                                    {(oindex < (Object.entries(value).length - 1)) && (
                                                        <span className='mld-1'>,</span>
                                                    )}
                                                </span>
                                            )
                                        })}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </>
        )
    }





    render() {

        let hasVariants = Array.isArray(this.state.choosen?.variants) && (this.state.choosen?.variants.length > 0 && this.state.choosen?.variants[0].options?.length > 0)
        let hasAdditionals = Array.isArray(this.state.choosen?.additionals) && this.state.choosen?.additionals.length > 0
        let isSubscription = this.state.choosen?.type == 'membership' && this.state.choosen?.priceType == 'subscription' && Array.isArray(this.state.choosen?.subscriptionPrice) == true && this.state.choosen?.subscriptionPrice?.length > 0

        return (
            <div className='mt-0 w-100 h-100 flexc ' style={{ position: 'relative' }}  >


                <div ref={ref => this.setWrapperRef(ref)} className="w-100" >

                    <div className="flexcb w-100 h-100" ref={el => this.currentNode = el} >
                        <div className="d-flex flex-column" onClick={() => { this.toggleOpen(true) }} style={{ flex: 1, cursor: 'pointer', overflow: 'hidden' }}>
                            {(!this.props.data || this.props.data == '' || !this.state.choosen?.title) && (
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mrd-1 mld-1 placeholder '}>{this.props.header.information.placeholder ? checkTextTranslation(this.props.header.information.placeholder) : 'Select'}</label>
                                </div>
                            )}

                            {(this.props.data && this.props.data != '' && this.state.choosen?.title) && (
                                <div className="d-flex text-start flex-column" style={{ flexWrap: 'nowrap', cursor: 'pointer', flex: 1 }}>
                                    <p style={{ whiteSpace: 'nowrap' }}>{this.state.choosen.title}</p>


                                    {this.showVariants(this.state.choosen)}

                                    {(hasAdditionals || hasVariants || isSubscription) && (
                                        <div className="flexc " style={{ marginTop: 2 }}>
                                            <button onClick={(e) => { e.stopPropagation(); this.variantsfixedView.showView() }} className="text-link text-smaller">{translate("Change variant")}</button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* {this.props.header.information?.search && (
                            <button onClick={() => this.openFilter()} className="flexcc">
                                <img src="https://www.flaticon.com/svg/static/icons/svg/3126/3126539.svg" height="20px" />
                            </button>
                        )} */}
                    </div>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 3, right: 5 }}>
                            <Loader
                                type="Oval"
                                color="#FF6C00"
                                height="20"
                                width="20"
                            />
                        </div>
                    )}



                    <FixedView width={240} ref={el => this.variantsfixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={7} bottomOffset={0} zIndex={5} xOffset={0} rightAlign={false}>

                        <div className="text-start sc-gray2 px-3 py-3 w-100 d-flex flex-column br-8" style={{ backgroundColor: '#ffffff', boxShadow: '0px 0px 20px #10101030', overflow: 'auto', display: 'flex', width: '100%', maxWidth: 300, maxHeight: 300, }}>
                            {/* <p>Choose variants</p> */}

                            {hasVariants && (
                                <SingleProductVariants product={this.state.choosen} activeVariants={this.state.activeVariants} setActiveVariant={this.setActiveVariant} />
                            )}

                            {hasAdditionals && (
                                <SingleProductAdditionals product={this.state.choosen} activeAdditionals={this.state.activeAdditionals} setActiveAdditionals={this.setActiveAdditionals} />
                            )}

                            {isSubscription && (

                                <SingleProductSubscriptions product={this.state.choosen} activeVariants={this.state.activeVariants} setActiveVariant={this.setActiveVariant} />

                            )}

                        </div>
                    </FixedView>



                    {/* {this.state.isOpen && ( */}
                    <FixedView width={240} ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={7} bottomOffset={0} zIndex={5} xOffset={0} rightAlign={false}>

                        <div className="text-start" style={{ display: 'flex', width: '100%', maxWidth: 300, padding: '0' }}>
                            <div className={'search-drop-down '} style={{ paddingBottom: 20, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 4, maxHeight: 300, overflow: 'auto', boxShadow: '0px 0px 20px #10101030', border: '1px solid #eee' }}>
                                {this.props.header.information.isSearchable && (
                                    <div className="p-1">
                                        <input autoFocus className="w-100" value={this.state.search} onChange={event => this.search(event.target.value)} placeholder={translate("useful.searchPlaceholder")} style={{ zIndex: 1, fontSize: 14, alignSelf: 'stratch', padding: '8px 10px', margin: 0, backgroundColor: '#fff', borderRadius: 4, border: '#e0e2e6 solid 1px', marginTop: 0, position: 'sticky', top: 0 }} />
                                    </div>
                                )}



                                {/* {this.state.options.length != 0 && (
                                    <div className="mt-2" onClick={() => this.changeItem({ value: '' })} style={{ cursor: 'pointer', backgroundColor: 'transparent', opacity: 0.5, padding: '5px 20px' }}>
                                        <p style={{ margin: 0, color: '#456', fontSize: 13 }}>{checkTranslation(this.props.header?.information?.defaultPlaceholder ?? "{{lang}}useful.choosePlaceholder")}</p>
                                    </div>
                                )} */}

                                {/* {this.state.parents?.map((prop, index) => {
                                    let selectableParent = this.props.header.information?.selectableParent
                                    let selected = false
                                    return (
                                        <div key={index}>
                                            {(!this.state.search || this.state.search == '') && (
                                                <div onClick={() => { if (selectableParent) this.changeItem(prop, selected) }} style={{ padding: '10px 20px', borderBottom: '1px solid #eee', marginBottom: 5, cursor: selectableParent ? 'pointer' : '' }}>
                                                    <p style={{ margin: 0, color: '#789', fontSize: 13 }}>{prop.title}</p>
                                                </div>
                                            )} */}
                                {this.state.options?.map((cprop, cindex) => {
                                    let cselected = false

                                    // if (cprop.parent == prop.value) {
                                    return (
                                        <div className="">
                                            <div className="flexc " key={cindex} onClick={() => this.changeItem(cprop, cselected)} style={{ cursor: 'pointer', backgroundColor: cselected ? '#f7f7f7' : '#transparent', padding: '5px 10px' }}>
                                                {this.props.header.information?.fields?.image && (
                                                    <div className="flexcc">
                                                        <img className="mrd-3" src={imageAddress(cprop.image, 'resource', 'small')} width="30px" height="30px" alt="" style={{ borderRadius: 40, objectFit: 'cover' }} />
                                                    </div>
                                                )}
                                                <div className="d-flex flex-column justify-content-center">
                                                    <p className="text-bold" style={{ margin: 0, color: '#000', fontSize: 13 }}>{cprop.title}</p>
                                                    {/* <p style={{ margin: 0, color: '#789', fontSize: 12, lineHeight: 1.2 }}>{cprop.description}</p> */}

                                                </div>
                                            </div>
                                        </div>
                                    )
                                    // }
                                })}
                                {/* </div> */}
                                {/* )
                                })} */}

                                {this.state.options.length == 0 && (
                                    <div className="px-2 pt-3">
                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                        {/* {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)} */}

                                    </div>
                                )}

                            </div>
                        </div>
                    </FixedView>
                    {/* )} */}

                </div>
                {/* {this.props.header.information?.search && ( */}
                <FilterModal ref={el => this.filterModal = el} headers={this.props.header.information?.search?.headers} initData={this.state.filter} />
                {/* )} */}

            </div >
        );
    }
}


export default ProductSelectInput;
